var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{staticClass:"text-center align-center justify-center align-content-center",attrs:{"value":_vm.InitLoading,"opacity":"0.8"}},[_c('v-progress-circular',{staticClass:"mb-2",attrs:{"color":"primary","indeterminate":"","size":"50"}}),_c('div',[_vm._v(" لطفا صبر کنید ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }